import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../index.module.scss';
import SuspenseLoader from 'src/components/SkeletonLoader/SuspenseLoader';
import LineLoader from 'src/components/SkeletonLoader/LineLoader';
import PendingPanApprovalListItem from './PendingPanApprovalListItem';

const ItemLoader = () => {
  return (
    <div className={styles.listItem}>
      <LineLoader lineStyle={styles.loaderAvatar} />
      <div>
        <LineLoader lineWidth={200} dimenshionUnit="px" numberOfLines={2} childrenType={'P5'} />
      </div>
    </div>
  );
};

const PendingPanApprovalList: React.FC = () => {
  const list = useSelector((state: RootState) => state.approvals.panList);
  const loading = useSelector((state: RootState) => state.approvals.loading);
  return (
    <div className={styles.listContainer}>
      <SuspenseLoader
        loading={loading}
        fallBack={
          <div>
            {Array.from({ length: 10 }, (_, index) => (
              <ItemLoader key={index} />
            ))}
          </div>
        }
      >
        {list.length ? (
          list.map((item, index) => (
            <PendingPanApprovalListItem approvalItem={item} key={item.referenceId} index={index} />
          ))
        ) : (
          <Typography variant={'p3'} className={styles.emptyListText}>
            No search results found
          </Typography>
        )}
      </SuspenseLoader>
    </div>
  );
};

export default PendingPanApprovalList;
